// extracted by mini-css-extract-plugin
export default {"pageWrap":"StrategiesTreeModelRoot_pageWrap__5Xp5e"};